export const Money = () => {
  return (
    <svg
      width="20"
      height="19"
      viewBox="0 0 20 19"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_7_40848)">
        <path
          d="M10 12.5C11.3807 12.5 12.5 11.3807 12.5 10C12.5 8.61932 11.3807 7.50003 10 7.50003C8.61929 7.50003 7.5 8.61932 7.5 10C7.5 11.3807 8.61929 12.5 10 12.5Z"
          stroke="#706A85"
          strokeWidth="1.4"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M18.75 5.00003H1.25V15H18.75V5.00003Z"
          stroke="#706A85"
          strokeWidth="1.4"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M18.75 8.12503C17.9693 7.99271 17.2491 7.62082 16.6891 7.06089C16.1292 6.50097 15.7573 5.78075 15.625 5.00003"
          stroke="#706A85"
          strokeWidth="1.4"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M15.625 15C15.7573 14.2193 16.1292 13.4991 16.6891 12.9392C17.2491 12.3792 17.9693 12.0074 18.75 11.875"
          stroke="#706A85"
          strokeWidth="1.4"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M1.25 11.875C2.03072 12.0074 2.75094 12.3792 3.31086 12.9392C3.87079 13.4991 4.24268 14.2193 4.375 15"
          stroke="#706A85"
          strokeWidth="1.4"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M4.375 5.00003C4.24268 5.78075 3.87079 6.50097 3.31086 7.06089C2.75094 7.62082 2.03072 7.99271 1.25 8.12503"
          stroke="#706A85"
          strokeWidth="1.4"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
      <defs>
        <clipPath id="clip0_7_40848">
          <rect width="20" height="20" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};
